import { Tooltip } from "@mui/material";
import useToggle from "../../../hooks/useToggle";
import ModalBox from "../../modal";
import TransferRoleModal from "../../../screens/my-projects/transfer-role-modal";
import {
  getDelegateSchedulingButtonLabel,
  hasDelegateData,
} from "../../../screens/my-projects/utils";
import { PrimaryButton } from ".";
import { TreeStructure } from "@phosphor-icons/react";

interface DelegateSchedulingButtonProps {
  label?: string;
  disabled?: boolean;
  id?: string;
  delegateData?: Array<{ email?: string }> | null;
}

export default function DelegateSchedulingButton({
  label,
  disabled = false,
  id,
  delegateData,
}: DelegateSchedulingButtonProps) {
  const [showAddMemberDilogbox, setShowAddMemberDilogbox] = useToggle(false);
  const buttonLabel = label ?? getDelegateSchedulingButtonLabel(delegateData);
  const modalTitle = hasDelegateData(delegateData)
    ? "Manage Delegates"
    : "Add Member";

  const handleTransferRoleClose = () => {
    setShowAddMemberDilogbox();
  };

  const handleTransferRoleClick = () => {
    setShowAddMemberDilogbox();
  };

  return (
    <>
      <Tooltip title="Enter the email of the team member for scheduling. They will receive a link to propose times and be added to the invite once a time is selected.">
        <PrimaryButton
          onClick={handleTransferRoleClick}
          disabled={disabled}
          size="small"
          startIcon={<TreeStructure />}
        >
          {buttonLabel}
        </PrimaryButton>
      </Tooltip>

      {showAddMemberDilogbox && (
        <ModalBox
          title={modalTitle}
          showFooter={false}
          onClose={handleTransferRoleClose}
        >
          <TransferRoleModal
            onClose={handleTransferRoleClose}
            id={id}
            delegateData={delegateData}
          />
        </ModalBox>
      )}
    </>
  );
}
